const HOSPITAL_STAFF = 'hospital-staff'
const DEALER_USER = 'dealer-user'
const FIELD_ENGINEER = 'field-engineer'
const PAEDIATRICIAN_ASSISTANT = 'paediatrician-assistant'
const USER_TXT = '/user'
const ADMIN = 'admin'
const DISTRICT_ADMINISTRATION = 'district-administration'
const DISTRICT_HOSPITALS = 'district-hospitals'
const COMMUNITY_HEALTH_CENTER = 'community-health-center'
const PRIMARY_HEALTH_CENTER = 'primary-health-center'
const AUXILIARY_NURSE_MIDWIFE = 'auxiliary-nurse-midwife'
const DISTRICT_COLLECTOR = 'district-collector'
const INSPECTION_OFFICER = 'inspection-officer'
const DISTRICT_HEALTH_OFFICER = 'district-health-officer'
const DISTRICT_HOSPITAL = 'district-hospital'
const PUBLIC_HEALTH_CENTRE = 'public-health-centre'
const ANGANWADI_CENTER = 'anganwadi-center'
const ANGANWADI_TEACHER = 'anganwadi-teacher'
const ANGANWADI_HELPER = 'anganwadi-helper'
const DOCTOR = 'doctor'
const PARENT = 'parent'
const CHILD = 'child'
const DASHBOARD_TXT = '/dashboard'
const PHOTOS = 'photos'
const NEW_DASHBOARD_TXT = '/new-dashboard'
const ICC_TXT = '/icc'

const pathName = {
  ROOT: '/',
  HOME: '/home',
  FIRST_AID: '/first-aid',
  DASHBOARD: `${DASHBOARD_TXT}/:type`,
  PHOTO_DASHBOARD: `${DASHBOARD_TXT}/${PHOTOS}/:photoType`,
  USER: `${USER_TXT}/:userType`,
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/forgot-password?:uuid',
  DATA_VISUALIZATION: '/data-visualization',
  ADD_USER: `${USER_TXT}/:userType/add`,
  PROFILE: `/profile`,
  DOCTOR_VIEW: `${USER_TXT}/doctor/view`,
  ADD_JOB: '/jobs/:jobType/add',
  JOBS: '/jobs',
  EDIT_JOB: '/jobs/:jobType/edit/:jobId',
  NOTIFICATIONS: `/notifications`,
  ICC: ICC_TXT,
}
export default pathName

export {
  USER_TXT,
  HOSPITAL_STAFF,
  DEALER_USER,
  FIELD_ENGINEER,
  PAEDIATRICIAN_ASSISTANT,
  ADMIN,
  DISTRICT_ADMINISTRATION,
  DISTRICT_HOSPITALS,
  COMMUNITY_HEALTH_CENTER,
  PRIMARY_HEALTH_CENTER,
  AUXILIARY_NURSE_MIDWIFE,
  PARENT,
  CHILD,
  DOCTOR,
  DISTRICT_COLLECTOR,
  INSPECTION_OFFICER,
  DISTRICT_HEALTH_OFFICER,
  DISTRICT_HOSPITAL,
  PUBLIC_HEALTH_CENTRE,
  ANGANWADI_CENTER,
  ANGANWADI_TEACHER,
  ANGANWADI_HELPER,
  DASHBOARD_TXT,
  PHOTOS,
  NEW_DASHBOARD_TXT,
  ICC_TXT,
}
